import { z } from 'zod';

export const alertSchema = z.object({
  get_content_object_display_name: z.string(),
  created_at: z.string(),
  updated_at: z.string(),
  id: z.number(),
  code: z.number(),
  lifecycle: z.string(),
  events: z.number(),
  extra: z.record(z.string(), z.any()),
  source: z.string(),
});

export const serviceAnomalySchema = z.object({
  level: z.string(),
  img: z.string(),
  text: z.string(),
  contentObject: z.string(),
  helpText: z.string(),
});

export type Alert = z.infer<typeof alertSchema>;
export type ServiceAnomaly = z.infer<typeof serviceAnomalySchema>;
